import React, { useEffect, useState } from "react";

/*
 * The Solstack app (xyz.solstack.app) in the Solana dApp Store, on Seeker and
 * Saga phones. The store has no web listing, only the solanadappstore://
 * deep link, so the badge points at the About page's "On your phone" section
 * and, in an Android browser, opens the listing through an intent URL that
 * falls back to that same section on a phone without the store. Android
 * WebViews (the X and Telegram in-app browsers among them) show an error page
 * for intent URLs, so they get the section too.
 */
export const DAPP_STORE_SECTION = "/about#solana-mobile";
const INTENT =
  "intent://details?id=xyz.solstack.app#Intent;scheme=solanadappstore;" +
  `S.browser_fallback_url=${encodeURIComponent(`https://solstack.xyz${DAPP_STORE_SECTION}`)};end`;
const SHELL_UA = "Solana Mobile Web Shell";

/** Solana Mobile's own "Get it on Solana dApp Store" badge
 * (public/img/solana-dapp-store-badge.svg, 232×91). Hidden inside the app
 * itself, whose WebView tags its user agent "Solana Mobile Web Shell". */
export const DappStoreBadge = ({ height = 40, className }) => {
  const [inShell, setInShell] = useState(false);
  // After mount, not during render: the prerendered HTML has no user agent.
  useEffect(() => setInShell(navigator.userAgent.includes(SHELL_UA)), []);
  if (inShell) return null;

  const open = (e) => {
    const ua = navigator.userAgent;
    if (!/Android/i.test(ua) || /; wv\)/.test(ua)) return;
    e.preventDefault();
    window.location.href = INTENT;
  };

  return (
    <a className={className} href={DAPP_STORE_SECTION} onClick={open}>
      <img
        src="/img/solana-dapp-store-badge.svg"
        alt="Get it on Solana dApp Store"
        width={Math.round((height * 232) / 91)}
        height={height}
        style={{ display: "block" }}
      />
    </a>
  );
};
